module.exports = __webpack_public_path__ + "img/lindinger-88023a5e-593d-4dd6-f7e8-08d9575a2ac9.png";